import React, { useEffect, useState, useRef } from "react";

//components
import BareIndicator from "components/UploadPage/RightSidebar/BareShow/BareIndicator";
import './index.scss'

function LeftPanel({
  currentTime,
  currentTrack,
  setCurrentTime,
  defaultTempo,
  timestamps,
}) {
  const [bottomPanelLeft, setBottomPanelLeft] = useState(0);
  const [localTimestamps, setLocalTimestamps] = useState([]);

  const bareShowRef = useRef(null);

  const containerWidth = bareShowRef?.current?.offsetWidth;
  const bareSize = containerWidth * 7 / 23;

  useEffect(() => {
    if (!timestamps.length) return;
    let newTimestamps = [];
    for (let i = 0; i < timestamps.length - 1; i++) {
      newTimestamps.push({
        startTime: timestamps[i],
        endTime: timestamps[i + 1],
      });
    }
    setLocalTimestamps(newTimestamps);
  }, [timestamps]);

  useEffect(() => {
    setBottomPanelLeft(-1 * Math.max(currentTrack - 1, 0) * bareSize * (9.0 / 7) + bareSize);
  }, [currentTrack, bareSize]);

  return (
    <div className="bare-show-wrapper" >
      <div className="bare-label">
        Bare
      </div>
      <div className="bares" ref={bareShowRef}>
        <div
          style={{
            display: "inline-flex",
            backgroundColor: "#22222200",
            position: "relative",
            left: bottomPanelLeft || 0,
            transition: "left 0.5s ease-in-out",
            boxSizing: 'border-box',
          }}
        >
          {localTimestamps.map((timestamp, index) => {
            return (
              <div
                key={index + 1}
                id={index + 1}
                style={{
                  height: bareSize,
                  width: bareSize,
                  padding: `${bareSize / 7}px`,
                  position: "relative",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentTime(timestamp.startTime);
                }}

              >
                <div
                  style={{
                    height: "0%",
                    width: "0%",
                    left: "0",
                    top: "0",
                    display: "flex",
                    justifyContent: "center",
                    position: "absolute",
                    color: "#00ff00",
                    background: 'red'
                  }}
                >
                </div>

                {
                  <BareIndicator
                    bareNumber={index + 1}
                    defaultTempo={defaultTempo}
                    currentTime={currentTime}
                    startTime={timestamp.startTime}
                    endtime={timestamp.endTime}
                    sepratorColor={"#222222"}
                    totalBares={timestamps.length}
                    size={`${bareSize * 0.45}px`}
                  />
                }
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default LeftPanel;
